import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@roberttamas/ui";
import { formatDistanceToNow } from "date-fns";
import { useTranslation } from "react-i18next";

import { currentDateFnsLocale } from "@/lib/locale-format";

export function RelativeTime({ date }: { date: Date | null }) {
  // Subscribes to language changes so the distance re-renders on switch.
  useTranslation();
  if (!date) return <span className="text-muted-foreground">-</span>;
  return (
    <TooltipProvider delayDuration={150}>
      <Tooltip>
        <TooltipTrigger asChild>
          <span className="cursor-default">
            {formatDistanceToNow(date, { addSuffix: true, locale: currentDateFnsLocale() })}
          </span>
        </TooltipTrigger>
        <TooltipContent>{date.toISOString()}</TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
